import { Injectable } from '@angular/core';
import { Config } from '../config';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../../managers/storage.service';
import { Schedules } from '../../../model/schedules';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SchedulesService extends Config {

  constructor(private httpClient: HttpClient,
    private storageService: StorageService) {
    super();
  }

  public createSchedule(schedule: Schedules): Observable<any> {
    var url;

    url = this.BASE_URL + "schedules_create";

    return this.httpClient.post(url, schedule, this.storageService.getHeaders());
  }
}
